export default "__VITE_ASSET__D6xV9SVM__"